// 内贸
import uploadIcon from '../../images/icon-upload.png'
import textIcon from '../../images/icon-text.png'
import webIcon from '../../images/icon-web.png'
import webIcon2 from '../../images/icon-web2.png'
// 海外
import uploadIcon2 from '../../images/icon-upload2.png'
import textIcon2 from '../../images/icon-text2.png'
import webIcon3 from '../../images/icon-web3.png'
import webIcon4 from '../../images/icon-web4.png'

export default function getIcons(geoMode) {
  if (geoMode === 'inner') {
    return {
      uploadIcon,
      textIcon,
      webIcon,
      webIcon2,
    }
  }
  return {
    uploadIcon: uploadIcon2,
    textIcon: textIcon2,
    webIcon: webIcon3,
    webIcon2: webIcon4,
  }
}
